import styled, {css} from 'styled-components';

import {media, flipOnLTR} from '~/shared/theme/utils';
import {LongButton} from '~/shared/components/Modals';
import Button from '~/shared/components/Button';
import {flexColumn} from '~/shared/theme/FlexLayout';

import {
  body13Normal,
  body14Normal,
  body16Bold,
  bodyBold,
  headingXS,
  smallBold,
  smallRegular,
} from '../theme/typography';

export const FormWrapper = styled.form`
  ${flexColumn}
  ${media.minMobile`
    margin-bottom:0;
  `}
`;

export const Body = styled.div`
  flex: 1 0 auto;
  ${flexColumn}
  padding: 0 20px 20px 20px;
  ${media.minMobile`
    padding: 20px 130px;
  `}
  position: static;
`;

export const ErrorText = styled.div.attrs(() => ({
  role: 'alert',
}))`
  ${body13Normal}
  line-height: 1em;
  color: ${({theme}) => theme.colors.contentError};
  ${flipOnLTR`
    text-align: right;
  `};
`;

export const FieldWrapper = styled.div<{isGov?: boolean}>`
  width: 100%;
  color: ${({theme}) => theme.colors.gray300};
  ${body14Normal}
  ${flipOnLTR`
    text-align: right;
  `};
  ${({isGov}) => !isGov && 'margin-top: 32px;'}
`;

export const FormContentRoot = styled.div`
  ${flexColumn}

  ${/* sc-selector */ FieldWrapper}:first-child {
    margin-top: 0;
  }

  a.existing-user-link {
    ${smallBold}
    color: ${({theme}) => theme.colors.contentDefault};
    text-decoration: underline;
    text-decoration-color: ${({theme}) => theme.colors.contentDefault};
  }
`;

export const LoginFormFieldsWrapper = styled.div`
  ${flexColumn}
`;

export const LoginBody = styled(Body)<{pageView?: boolean}>`
  padding: 32px 16px 20px;
  ${media.minLargeMobile`
    padding: 32px 40px 44px;
  `};
  ${({pageView}) => pageView && css`
    width: 100%;
    padding-top: 10px;
    ${media.minMobile`
      width: 550px;
      margin: 0 auto;
    `}
  `}
`;

export const BodyWrapper = styled.div<{backgroundColor?: string; pageView?: boolean}>`
  background-color: ${({backgroundColor, theme}) => backgroundColor || theme.colors.surface};
  position: static;
  ${media.minTablet`
    ${({pageView}) => pageView && `
      width: 100%;
      height: auto;
      margin: 0 auto;
      border-bottom-left-radius: 16px;
      border-bottom-right-radius: 16px;
    `}
  `}
`;

export const HeaderText = styled.div`
  ${headingXS}
  color: ${({theme}) => theme.colors.contentDefault};
  text-align: center;
  margin: 0;
`;

export const Email = styled(HeaderText)`
  ${bodyBold}
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
`;

export const SubmitButton = styled(LongButton)`
  border-radius: 0;
`;

export const BlackLinkButton = styled(Button)<{isGov?: boolean}>`
  color: ${({theme}) => theme.colors.contentDefault};
  ${({isGov}) => (isGov ? body16Bold : bodyBold)};

  &&& {
    ${({isDisabled, theme}) => isDisabled && `
      color: ${theme.colors.gray500};
      background: transparent;
    `}
  }
`;

export const LinkButtonsWrapper = styled.div`
  margin-top: 24px;
  padding: 10px 0;
  ${flexColumn}
`;

export const StyledErrorText = styled(ErrorText)`
  position: absolute;
  width: 100%;
  top: 84px;
  height: 15px;
`;

export const LoginWithSectionHeader = styled.div`
  overflow: hidden;
  text-align: center;
  ${smallRegular}
  margin: 18px 0;
  color: ${({theme}) => theme.colors.contentPlaceholder};

  &::before,
  &::after {
    background-color: ${({theme}) => theme.colors.borderStrong};
    content: '';
    display: inline-block;
    height: 1px;
    position: relative;
    vertical-align: middle;
    width: 50%;
  }

  &::before {
    right: 20px;
    margin-left: -50%;
  }

  &::after {
    left: 20px;
    margin-right: -50%;
  }
`;
